const getArraysDifference = (arr1, arr2) => {
    return arr1
        .filter((x) => !arr2.includes(x))
        .concat(arr2.filter((x) => !arr1.includes(x)));
};
const arrayAddIf = (condition, value) => {
    if (condition) {
        return Array.isArray(value) ? value : [value];
    }
    return [];
};
const filteredArray = (arr, filterFalseValue = false) => {
    return arr.filter((val) => val !== undefined &&
        val !== null &&
        (filterFalseValue ? !!val : true));
};
const mapToLabelValue = (array) => {
    return array === null || array === void 0 ? void 0 : array.map((item) => ({
        label: item,
        value: item
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, ""),
    }));
};
const getJoinedStringFromArray = (arr, separator = ", ", filterItem = true) => {
    let _ = arr;
    if (filterItem) {
        _ = filteredArray(arr, filterItem);
    }
    return _.join(separator);
};
function toggleArrayValue(array, value) {
    const index = array.indexOf(value);
    if (index === -1) {
        // Value does not exist in array, add it
        return [...array, value];
    }
    else {
        // Value exists in array, remove it
        return array.filter((item) => item !== value);
    }
}
function getUniqueArray(arr) {
    return Array.from(new Set(arr));
}

export { arrayAddIf, filteredArray, getArraysDifference, getJoinedStringFromArray, getUniqueArray, mapToLabelValue, toggleArrayValue };
//# sourceMappingURL=array.js.map
